import store from '@/store';
import {
  LOGIN_PAGE_ID_CHANGE_PASSWORD,
  LOGIN_PAGE_ID_CONFIGURE_SECOND_FACTOR,
  LOGIN_PAGE_ID_FORGOT_PASSWORD,
  LOGIN_PAGE_ID_GOOGLE_LOGIN,
  LOGIN_PAGE_ID_LOGIN,
  LOGIN_PAGE_ID_RECOVER_PASSWORD,
  LOGIN_PAGE_ID_SECOND_FACTOR,
} from '@/modules/authentication/config/login-routes';
import AuthUserPasswordLogin from '@/modules/authentication/components/AuthUserPasswordLogin.vue';
import AuthChangePassword from '@/modules/authentication/components/AuthChangePassword.vue';
import AuthForgotPassword from '@/modules/authentication/components/AuthForgotPassword.vue';
import AuthRecoverPassword from '@/modules/authentication/components/AuthRecoverPassword.vue';
import AuthGoogleLogin from '@/modules/authentication/components/AuthGoogleLogin.vue';
import AuthSecondFactorLogin from '@/modules/authentication/components/AuthSecondFactorLogin.vue';
import AuthSecondFactorConfiguration from '@/modules/authentication/components/AuthSecondFactorConfiguration.vue';

export interface LoginPage {
  id: string;
  component: Object;
  default?: boolean;
}

export const loginPages: LoginPage[] = [
  {
    id: LOGIN_PAGE_ID_LOGIN,
    component: AuthUserPasswordLogin,
  },
  {
    id: LOGIN_PAGE_ID_CHANGE_PASSWORD,
    component: AuthChangePassword,
  },
  {
    id: LOGIN_PAGE_ID_FORGOT_PASSWORD,
    component: AuthForgotPassword,
  },
  {
    id: LOGIN_PAGE_ID_RECOVER_PASSWORD,
    component: AuthRecoverPassword,
  },
  {
    id: LOGIN_PAGE_ID_GOOGLE_LOGIN,
    component: AuthGoogleLogin,
  },
  {
    id: LOGIN_PAGE_ID_SECOND_FACTOR,
    component: AuthSecondFactorLogin,
  },
  {
    id: LOGIN_PAGE_ID_CONFIGURE_SECOND_FACTOR,
    component: AuthSecondFactorConfiguration,
  },
];

export const registerLoginPage = (loginPage: LoginPage) => {
  if (loginPage.default) {
    loginPages.forEach((page) => {
      page.default = false;
    });
  }
  loginPages.push(loginPage);
};

export const getDefaultLoginPage = () => {
  const defaultPage = loginPages.find(loginPage => loginPage.default);
  if (!defaultPage) {
    return getLoginPageById(store.getters.oAuthEnabled ? LOGIN_PAGE_ID_GOOGLE_LOGIN : LOGIN_PAGE_ID_LOGIN);
  }
  return defaultPage;
};

export const getDefaultLoginPageId = () => {
  const defaultLoginPage = getDefaultLoginPage();
  if (!defaultLoginPage) {
    console.warn('There is not a default login page.');
    return store.getters.oAuthEnabled ? LOGIN_PAGE_ID_GOOGLE_LOGIN : LOGIN_PAGE_ID_LOGIN;
  }
  return defaultLoginPage.id;
};

export const loginPageExists = (id: string) => getLoginPageById(id) !== undefined;

export const getLoginPageById = (id: string) => loginPages.find(loginPage => loginPage.id === id);
